import React from 'react';
import { Route, IndexRoute, Redirect, browserHistory } from 'react-router';
import { isUndefined, isEmpty } from 'lodash';
import Configuration from '../common/Configuration.json';
import AddressIdUtil from '../common/AddressIdUtil';
import AppStore from '../redux/store/AppStore';
import HomeContainer from '../redux/containers/HomeContainer';
import CheckoutContainer from '../redux/containers/CheckoutContainer';
import Payment from '../components/payment/Payment/Payment';
import ZuoraCallback from '../components/zuora/ZuoraCallback/ZuoraCallback';
import SuccessContainer from '../redux/containers/SuccessContainer';
import GenericError from '../components/Error/Error';
import App from '../components/App/App';
import UpdatePaymentContainer from '../redux/containers/UpdatePaymentContainer';
import DashboardContainer from '../redux/containers/DashboardContainer';
import LoginContainer from '../redux/containers/LoginContainer';
import LoginAuthentication from '../components/Login/LoginAuthentication';
import LogoutContainer from '../redux/containers/LogoutContainer';
import ConfirmPayNowContainer from '../redux/containers/ConfirmPayNowContainer';
import ForgotPasswordFormContainer from '../redux/containers/ForgotPasswordFormContainer';
import ResetPasswordFormContainer from '../redux/containers/ResetPasswordFormContainer';
import SupportContainer from '../redux/containers/SupportContainer';
import SupportArticlesContainer from '../redux/containers/SupportArticlesContainer';
import { PlansSelector } from '../redux/reducers/PlansReducer';
import ContactUs from '../components/ContactUs/ContactUs';
import LineTest from '../components/LineTest/LineTest';
import ContactSuccessContainer from '../redux/containers/ContactSuccessContainer';
import ChangeContainer from '../redux/containers/ChangeContainer';
import MoveContainer from '../redux/containers/MoveContainer';
import SubmitCase from '../components/Change/SubmitCase';
import ConfirmChangeContainer from '../redux/containers/ConfirmChangeContainer';
import ReSignContainer from '../redux/containers/ReSignContainer';
import { SuccessSelector } from '../redux/reducers/SuccessReducer';
import PlanIdUtil from '../common/PlanIdUtil';
import ClickComponent from '../components/clickPayment/ClickComponent';

const indexRouteHandler = () => {
  const state = AppStore.getState();
  if (state.myAccount.loggedIn) {
    browserHistory.push('/dashboard');
    return null;
  }
  const sessionAddressId = AddressIdUtil.getAddressIdFromSession();
  if (sessionAddressId) {
    browserHistory.push(`/plans?addressId=${sessionAddressId}`);
    return null;
  }
  window.location = Configuration.homeUrl;
  return null;
};

const plansRouteHandler = (props) => {
  // const addressId = AddressIdUtil.getAddressIdFromQueryString(props);
  // const planId = PlanIdUtil.getPlanIdFromQueryString(props);
  const uuid = PlanIdUtil.getUUIdFromQueryString(props);
  // if (planId) {
  //   PlanIdUtil.setPlanIdToSession(planId);
  // }
  // if (addressId) {
  //   AddressIdUtil.setAddressIdToSession(addressId);
  // }
  if (uuid) {
    return <HomeContainer uuid={uuid} {...props} />;
  }
  // const sessionAddressId = AddressIdUtil.getAddressIdFromSession();
  // const sessionplanId = PlanIdUtil.getPlanIdFromSession();

  const sessionUUId = PlanIdUtil.getUUIdFromSession();
  if (sessionUUId) {
    browserHistory.push(
      `/plans?id=${sessionUUId}`
    );
    return null;
  }
  // if (sessionAddressId && sessionplanId) {
  //   browserHistory.push(
  //     `/plans?addressId=${sessionAddressId}&planId=${sessionplanId}`
  //   );
  //   return null;
  // }
  window.location = Configuration.homeUrl;
  return null;
};

const redirectToRoot = (nextState, replace) => {
  replace({
    pathname: '/',
    state: { nextPathname: nextState.location.pathname }
  });
};

const redirectToPlans = (nextState, replace) => {
  replace({
    pathname: '/plans',
    state: { nextPathname: nextState.location.pathname }
  });
};

const redirectToCheckout = (nextState, replace) => {
  replace({
    pathname: '/checkout',
    state: { nextPathname: nextState.location.pathname }
  });
};

const isInvalidPlan = state => isUndefined(PlansSelector.getSelectedPlan(state));

const validateContactSubmitted = (nextState, replace) => {
  const state = AppStore.getState();
  const contactUs = state.form.contactUs;
  if (!contactUs || contactUs.submitSucceeded === false) {
    redirectToRoot(nextState, replace);
  }
};

const validatePayment = (nextState, replace) => {
  const state = AppStore.getState();
  const acceptTermsNotSelected = state.form.checkout && state.form.checkout.values &&
    state.form.checkout.values.acceptTerms === false;
  if (state.plans.isContractSelected) { // Payment page is only used for open term customers
    redirectToCheckout(nextState, replace);
  }
  if (isInvalidPlan(state) || acceptTermsNotSelected) {
    redirectToPlans(nextState, replace);
  }
};

const validateCheckout = (nextState, replace) => {
  const state = AppStore.getState();
  if (isInvalidPlan(state)) {
    redirectToPlans(nextState, replace);
  }
};

const validateSuccess = (nextState, replace) => {
  const state = AppStore.getState();
  const plan = SuccessSelector.getPlan(state);
  if (isEmpty(plan)) {
    redirectToPlans(nextState, replace);
  }
};

const validateLoggedIn = (nextState, replace) => {
  const state = AppStore.getState();
  if (!state.myAccount.loggedIn) {
    replace({ pathname: '/login', state: { nextPathname: nextState.location.pathname } });
  }
};

const validateLoggedInAndHasCustomerData = (nextState, replace) => {
  validateLoggedIn(nextState, replace);
  const state = AppStore.getState();
  if (state.plans.contractPlans.length === 0) {
    replace({ pathname: '/dashboard', state: { nextPathname: nextState.location.pathname } });
  }
};

const validateChangeCardEnabled = (nextState, replace) => {
  validateLoggedIn(nextState, replace);
  const state = AppStore.getState();
  if (state.myAccount.customerInfo.featuresChangeCardDisabled) {
    replace({ pathname: '/dashboard', state: { nextPathname: nextState.location.pathname } });
  }
};

const validatePayOutstandingEnabled = (nextState, replace) => {
  validateLoggedIn(nextState, replace);
  const state = AppStore.getState();
  if (state.myAccount.customerInfo.featuresPayOutstandingDisabled) {
    replace({ pathname: '/dashboard', state: { nextPathname: nextState.location.pathname } });
  }
};

const validateLoggedOut = (nextState, replace) => {
  const state = AppStore.getState();
  if (state.myAccount.loggedIn) {
    replace({ pathname: '/dashboard', state: { nextPathname: nextState.location.pathname } });
  }
};

const routes = (
  <Route>
    <Route path="/test-click-payment" component={ClickComponent} />
    <Route path="/zuora-callback" component={ZuoraCallback} />
    <Route path="/authentication/login?error" component={LoginAuthentication} />
    <Route path="/" component={App}>
      <IndexRoute component={indexRouteHandler} />
      <Route path="/plans" component={plansRouteHandler} />
      <Route path="/checkout" component={CheckoutContainer} onEnter={validateCheckout} />
      <Route path="/payment" component={Payment} onEnter={validatePayment} />
      <Route path="/success" component={SuccessContainer} onEnter={validateSuccess} />
      <Route path="/error" component={GenericError} />
      <Route path="/login" component={LoginContainer} onEnter={validateLoggedOut} />
      <Route path="/dashboard" component={DashboardContainer} onEnter={validateLoggedIn} />
      <Route path="/dashboard/:changeInProgress" component={DashboardContainer} onEnter={validateLoggedIn} />
      <Route path="/update-payment" component={UpdatePaymentContainer} onEnter={validateChangeCardEnabled} />
      <Route path="/confirm-pay-now" component={ConfirmPayNowContainer} onEnter={validatePayOutstandingEnabled} />
      <Route path="/logout" component={LogoutContainer} onEnter={validateLoggedIn} />
      <Route path="/forgot-password" component={ForgotPasswordFormContainer} />
      <Route path="/reset-password" component={ResetPasswordFormContainer} />
      <Route path="/support-centre" component={SupportContainer} />
      <Route path="/change" component={ChangeContainer} onEnter={validateLoggedInAndHasCustomerData} />
      <Route path="/move" component={MoveContainer} onEnter={validateLoggedInAndHasCustomerData} />
      <Route
        path="/confirm-change/:name"
        component={ConfirmChangeContainer}
        onEnter={validateLoggedInAndHasCustomerData}
      />
      <Route path="/line-test" component={LineTest} onEnter={validateLoggedIn} />
      <Route path="/submit-case" component={SubmitCase} onEnter={validateLoggedIn} />
      <Route path="/contact-us(/:type(/:subtype))" component={ContactUs} />
      <Route path="/contact-success" component={ContactSuccessContainer} onEnter={validateContactSubmitted} />
      <Route
        path="/support-centre/:categoryId(/:articleId)"
        component={SupportArticlesContainer}
      />
      <Route
        path="/resign"
        component={ReSignContainer}
      />
      <Redirect from="*" to="/" />
    </Route>
  </Route>
);

export default routes;



/** WEBPACK FOOTER **
 ** ./src/routes/routes.js
 **/